import React from 'react';
import './headernavs.css'

const Navsheader = (props) => {
    return ( 
        <li className='header-navs'>{props.title}</li>
     );
}
 
export default Navsheader;